import React from "react";
import { TiTimes } from "react-icons/ti";

type CheckboxProps = {
  label?: string;
  name?: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
  readOnly?: boolean;
};

const Checkbox = ({
  label,
  name,
  checked,
  onChange,
  disabled,
  readOnly = false,
}: CheckboxProps) => {
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <div
      className="flex items-center space-x-2"
      onClick={readOnly ? undefined : () => onChange(!checked)}
    >
      {readOnly ? (
        <div className="bg-gray-400 rounded">
          <TiTimes className="text-white" size={18} />
        </div>
      ) : (
        <input
          type="checkbox"
          id={name}
          name={name}
          checked={checked}
          onChange={handleCheckboxChange}
          className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
          disabled={disabled}
        />
      )}
      {label && (
        <label htmlFor={name} className="font-medium text-gray-700">
          {label}
        </label>
      )}
    </div>
  );
};

export default Checkbox;
